// Live: https://analytics.google.com/analytics/web/#/p388304744/reports/intelligenthome
// Test: https://analytics.google.com/analytics/web/#/p390678145/reports/intelligenthome
export const getGTagTrackingId = () =>
  process.env.ENV === 'live' ? 'G-CC1KFZELCB' : 'G-MDTDV5V83C';

export const trackPageView = () => {
  const { href, pathname, hash, search } = window.location;

  // Note: DO NOT remove query param in the URL
  // Which will accidentally block many tracking features of GA
  const pageViewObject = {
    page_title: pathname + hash,
    page_location: href,
    page_path: pathname + search + hash,
    send_to: getGTagTrackingId(),
  };

  window.gtag('event', 'page_view', pageViewObject);
};

/*
gtag signature:
gtag('event', <action>, {
  'event_category': <category>,
  'event_label': <label>,
  'value': <value>
});
 */

export const trackArticleHelpfulness = (article, isHelpful) => {
  window.gtag('event', `${isHelpful ? 'Helpful' : 'Not Helpful'} clicked`, {
    event_category: 'Article Performance',
    event_label: `Article ${article.id}`,
    article_title: article.title,
    article_url: window.location.pathname,
  });
};

export const trackEnterContactForm = () => {
  window.gtag('event', 'Enter', {
    event_category: 'Contact Form',
  });
};

export const trackSubmitContactForm = () => {
  window.gtag('event', 'Submit', {
    event_category: 'Contact Form',
  });
};

export const trackNoResultFound = () => {
  window.gtag('event', 'Key Entered On Search Bar', {
    event_category: 'Site Search No Results Found',
    event_label: 'Search Term',
  });
};

export const trackSOPTouchpoint = () => {
  window.gtag('event', 'click_footer_open_platform', {
    event_category: 'Touchpoint',
  });
};
